import React from "react";
import {BoxLoadingContainer} from "./style";

export const BoxLoading = (props) => {
    return (
        <BoxLoadingContainer size={props && props.size}>
            <div className="dot-flashing" />
        </BoxLoadingContainer>
    );
};
